import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f4b1aca2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f4b1aca2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b1aca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\word\\aiks-big-screen-v1-shanxi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4b1aca2')) {
      api.createRecord('f4b1aca2', component.options)
    } else {
      api.reload('f4b1aca2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f4b1aca2&scoped=true", function () {
      api.rerender('f4b1aca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/myTitle/index.vue"
export default component.exports